export default class PostMessage {
  constructor({ origin, target }) {
    this.origin = origin || '*'
    this.target = target || parent
  }

  handle(context, event) {
    if (event === 'after:end') {
      this.target.postMessage({
        type: 'labjs.data',
        metadata: {
          payload: 'full',
          url: window.location.href,
        },
        data: context.options.datastore.data,
      }, this.origin)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/postmessage.js